import AssignmentMark from "./AssignmentMark";

const AssignmentMarkList = ({ assignmentMarks, isLoading, isError }) => {
  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div className="text-center">Loading...</div>;
  }

  if (!isLoading && isError) {
    content = (
      <div className="text-center text-red-500">Internal server error!</div>
    );
  }

  if (!isLoading && !isError && assignmentMarks?.length === 0) {
    content = <div className="text-center">No assignment marks found!</div>;
  }

  if (!isLoading && !isError && assignmentMarks?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Assignment</th>
            <th className="table-th">Date</th>
            <th className="table-th">Student Name</th>
            <th className="table-th">Repo Link</th>
            <th className="table-th">Mark</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-600/50">
          {assignmentMarks.map((assignmentMark) => (
            <AssignmentMark
              key={assignmentMark.id}
              assignmentMark={assignmentMark}
            />
          ))}
        </tbody>
      </table>
    );
  }

  return <div className="overflow-x-auto mt-4">{content}</div>;
};

export default AssignmentMarkList;
